import {Button, Stack} from '@mui/material';
import {RefundTaggingEnum} from 'main/analytics/gaTagsEnum';
import {AlertModal} from 'presentation/components';
import {HomeEnum} from 'presentation/constants';
import {translations} from 'presentation/translations-new';
import React from 'react';
import {useNavigate} from 'react-router-dom';
import {RefundFinishedModalProps} from './types';

const {notice} = translations['pt-br'].commons;
const {description, title} =
	translations['pt-br'].privateFlow.refund.additionalDocuments.refundFinishedModal;

const {backButton, backToRefund} = translations['pt-br'].privateFlow.refund.additionalDocuments;

export const RefundFinishedModal = ({open, setOpen}: RefundFinishedModalProps) => {
	const navigate = useNavigate();

	const handleNavigate = () => {
		navigate(HomeEnum.HOME_PAGE);
	};

	return (
		<AlertModal
			data-tag-id={RefundTaggingEnum.VISUALIZOU_MODAL_IMPOSSIVEL_ADICIONAR_DOCUMENTOS}
			closeBtnDataTagId={RefundTaggingEnum.CLICK_FECHAR_MODAL_IMPOSSIVEL_ADICIONAR_DOCUMENTOS}
			open={open}
			headerTitle={notice}
			title={title}
			description={description}
			onClose={() => setOpen(prev => !prev)}
			variant="info"
			footerContent={
				<Stack gap={1} sx={{width: '100%'}}>
					<Button
						fullWidth
						size="large"
						variant="outlined"
						onClick={handleNavigate}
						data-tag-id={
							RefundTaggingEnum.CLICK_VOLTAR_PARA_TELA_INICIAL_MODAL_IMPOSSIVEL_ADICIONAR_DOCUMENTOS
						}>
						{backToRefund}
					</Button>
					<Button
						data-tag-id={
							RefundTaggingEnum.CLICK_VOLTAR_PARA_ENVIO_MODAL_IMPOSSIVEL_ADICIONAR_DOCUMENTOS
						}
						fullWidth
						size="large"
						variant="contained"
						onClick={() => setOpen(prev => !prev)}>
						{backButton}
					</Button>
				</Stack>
			}
		/>
	);
};
